<template>
  <div page_id="withdrawal_page" class="page-withdrawal" ref="withdrawal">
    <bCardHeader :param="param" class="card-header" :buttons="buttons"></bCardHeader>
    <el-row class="row-wrap" :gutter="30">
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="p0">
        <div v-loading="formLoading" element-loading-text="加载中" element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.3)" class="card-base card-shadow--small fund-transfer left-card">
          <div class="withdrawal-title">{{$t('withdrawal.card_title1')}}</div>
          <div v-if="this.withdrawal_method == 'OVERSEA'" class="oversea-notices">
            <img src="../../../assets/images/notice.png">
            <b>{{$t('withdrawal.withdrawalCare')}}</b>
          </div>
          <el-radio-group v-model="withdrawal_method">
            <el-radio-button test_id="local_withdraw" label="LOCAL">{{$t('withdrawal.local')}}</el-radio-button>
            <el-radio-button test_id="oversea_withdraw" label="OVERSEA">{{$t('withdrawal.oversea')}}</el-radio-button>
          </el-radio-group>
          <component :is="formComponent" ref="withdrawalForm" :cashList='cashList' @submitFn='submitFn'
            :bankCardNumber='bankCardNumber' :allOtherBanks="allOtherBanks" @getAccountNumber='getAccountNumber'
            @resetWithdrawalForm='resetWithdrawalForm' @isNeedPointFun="isNeedPointFun" @showDialog="showDialogHandle" />
          <!-- <Form ref="withdrawalForm"
                :cashList='cashList'
                @submitFn='submitFn'
                :bankCardNumber='bankCardNumber'
                @getAccountNumber='getAccountNumber'
                @resetWithdrawalForm='resetWithdrawalForm' /> -->
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="p0 withdrawal-records">
        <bThreeList @cencelFun="cencelFun" type="withdrawal" :params="parentList" listTitle="WITHDRAWAL" :src='src'
          :router="router" :text="$t('withdrawal.noWithdrawal')"></bThreeList>
      </el-col>
    </el-row>
    <!-- 温馨提示 -->
    <el-row>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <div class="wrapper" v-if="this.withdrawal_method=='LOCAL'">
          <div class="note" v-html="$t('withdrawal.note')"></div>
        </div>
        <div class="wrapper" v-else>
          <div class="note" v-html="$t('withdrawal.oversea_note')"></div>
        </div>
      </el-col>
    </el-row>
    <!-- 撤销弹窗 -->
    <bCancelDialog :dialogVisible.sync="IsCancelShow" type="withdrawal" :closeModal="closeModal"
      :loading.sync="loadingSub" :handle="cancelWithdrawal"></bCancelDialog>
    <!-- 获取申请码弹窗 -->
    <bDialog :dialogVisible.sync="IsCodeShow" :refresh="refresh" @closeChange="closeChange" :params="dialogParams"
      :closeModal="closeModal" :component="componentDialog1" :contiune="contiune" :showClose="showClose"></bDialog>
    <!-- 预览提交信息弹窗 -->
    <bPreviewDialog :params="previewData" :loading="loading" :specialsubTip="subTip" type='attention'
      :handle="withdrawal_method == 'LOCAL' ? handle : confirm" :closeModal="closeModal" :sellRate="sellRate"
      :dialogVisible.sync="dialogVisible" :currency="withdrawalAmountCurrency" @closeHandle="closeHandle">
      <!-- 强制平仓提示 -->
      <!-- <template v-if="isNeedPoint">
        <div class="liquidation-box">{{$t('withdrawal.liquidation')}}</div>
        <div class="check-box">
          <el-checkbox class="checkboxTips" v-model="isChecked">{{$t('withdrawal.konwtext')}}</el-checkbox>
        </div>
      </template> -->
      <!-- 外汇平仓提示 -->
      <template v-if="this.type==='FOREX'">
        <div class="check-box">
          <el-checkbox class="checkboxTips" v-model="isChecked">{{$t('withdrawal.konwtext')}}</el-checkbox>
        </div>
      </template>
      <template v-if="isOtherBank">
        <div class="check-box-band" @click="checkRadioHandle">
          <img :src="require(`../../../assets/images/${isBandChecked?'icon_sel@2x':'icon_nor@2x'}.png`)" alt="">
          <span>{{$t('withdrawal.bandBank')}}</span>
        </div>
        <div class="warn-info">{{$t('withdrawal.warnBandBank')}}</div>
      </template>
    </bPreviewDialog>
    <el-dialog :title="dialogtitle" :visible.sync="showDialog" width="30%" class="warn-dialog" :show-close="false">
        <div class="dialog-info">{{$t('accountInfo.forbidWithdrawal')}}</div>
        <div class="dialog-footer">
          <el-button type="primary" @click="showDialog = false">{{$t('common.iknow')}}</el-button>
        </div>
      </el-dialog>
      <el-dialog class="error-dialog"
                  :visible.sync="spdialogOpen"
                  :title="$t('logout.tips')"
                  width="30%">
                  <div>{{$t('common.spInfo')}}</div>
                  <div slot="footer" class="footer-box">
                    <el-button style="width:40%;margin-left:0;" type="primary" @click="spdialogOpen=false">{{$t('common.ok')}}</el-button>
                  </div>
     </el-dialog>
     <el-dialog
                :visible.sync="popupVisible"
                width="30%"
                class="fund-box"
                :before-close="handlePopClose"
                :close-on-click-modal="false">
      {{$t('common.dormantDetailTip')}}
      <div class="btn-box btn-box-one">
        <div class="top"
              @click="handlePopClose">{{$t('common.cancel')}}</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import complete1 from '../fund-transfer/info-dialog.vue'
import { mapGetters, mapState } from 'vuex'
// import accountTypeConfig from '@/config/accountTypeConfig'
import uploadPicture from './components/uploadPicture'
import localForm from './components/withdrawalForm'
// import proxyApi from '@/api/proxy-api'
import api from '@/api/v2/trade'
import api1 from '@/api/v2/withdrawal'
import exchangeRateApi from '@/api/v2/exchangeRate'
import { settlementAccount } from '@/api/v2/deposit'
import { getAllBank } from '@/api/v2/fund'
// import _ from 'lodash'
import overseaForm from './components/overseaForm'
import moment from 'moment'
export default {
  components: { uploadPicture, confirm, localForm, overseaForm },
  data() {
    var checkWithdrawalName = (rule, value, callback) => {
      // var reg = /^([A-Za-z]+\s?)*[A-Za-z]$/ // 字符头尾是字母，中间由空格和字母组成，中间只有一个空格，如：Taylor Gre Swift
      if (!this.form.withdrawal_name) {
        callback(new Error(this.$t('withdrawal.error_withdrawal_name')))
        // }else if(!reg.test(value)){
        //   callback(new Error(this.$t("withdrawal.error_withdrawal_name")))
      } else {
        callback()
      }
    }
    var checkedVal = (rule, value, callback) => {
      console.log(rule, value)
      var f = rule.field
      if (!this[f]) {
        return callback(new Error(this.$t('applyTradeAccount.checked')))
      }
      callback()
    }
    return {
      text: 'noWithdrawal',
      src: require('@/assets/images/noWithdrawal.png'),
      componentDialog1: complete1, // 弹窗内容
      buttons: [],
      router: 'withdrawal',
      IsCancelShow: false,
      param: {
        title: 'withdrawalTitle',
        links: [
          {
            title: 'home'
          },
          {
            title: 'withdrawalTitle'
          }
        ]
      },
      tmp_account_number: '',
      closeModal: false,
      orderId: '',
      loadingSub: false,
      bankCardNumber: [],
      available_fund: '',
      currency: '--', // 币种
      currencyOption: '', // 选择的币种
      currencyOptionText: {
        'HKD': this.$t('common.hkd'),
        'USD': this.$t('common.usd'),
        'CNY': this.$t('common.cny')
      },
      form: {
        tradeAccount: '',
        bank_card_number: '',
        withdrawal_amount: '',
        bankType: ''
      },
      previewData: {},
      accountId: '',
      bank_card_name: '',
      parentList: [],
      withdrawal_method: 'LOCAL',
      submittedOrder: [],
      showClose: false, // 关闭小图标
      contiune: true, // 继续按钮
      IsCodeShow: false,
      dialogVisible: false, // 默认关闭弹窗
      loading: false,
      accountInfo: '',
      accountNumber: '',
      availableFundShow: true,
      params: {
        orderId: ''
      },
      currencyList: [],
      withdrawalCurrency: '--',
      withdrawalCurrencys: [],
      currencyIocnList: [],
      currencyIocn: '',
      withdrawalCurrencyIocn: '',
      withdrawalCurrencyIocnList: [],
      accountType: '',
      tradeAccountType: '',
      oldListData: [],
      cancelOrderId: '',
      cashList: [],
      showBalance: true,
      checked: false,
      imageKeys: [],
      allOtherBanks: [],
      subTip: '',
      rate: 0,
      rules: {
        checked: [
          {
            validator: checkedVal
          }
        ],
        withdrawal_name: [
          {
            validator: checkWithdrawalName,
            required: true,
            // message: this.$t("withdrawal.error_withdrawal_name"),
            trigger: 'change'
          }
        ],
        withdrawal_bank_name: [
          {
            required: true,
            message: this.$t('withdrawal.error_withdrawal_bank_name'),
            trigger: 'change'
          }
        ],
        withdrawal_bank_card: [
          {
            required: true,
            message: this.$t('withdrawal.error_withdrawal_bank_card'),
            trigger: 'change'
          }
        ],
        withdrawal_swift_no: [
          {
            required: true,
            message: this.$t('withdrawal.error_withdrawal_swift_no'),
            trigger: 'change'
          }
        ]
      },
      type: '',
      subLoading: false,
      formLoading: false,
      formComponent: 'localForm',
      oldBankCardNumber: [],
      cnyRate: '',
      usdRate: '',
      sellRate: '',
      isNeedPoint: false,
      isChecked: false,
      isOtherBank: false,
      isBandChecked: false,
      showDialog: false,
      dialogtitle: this.$t('logout.tips'),
      spdialogOpen: false,
      isDormant: false,
      popupVisible: false
    }
  },
  computed: {
    ...mapGetters(['getUser', 'valueAccountNumber', 'getClientProfile', 'getAccountInfo']),
    ...mapState(['userInfo', 'filterSPTradingAccountList']),
    firstName() {
      return this.getClientProfile && this.getClientProfile.userInfo ? this.getClientProfile.userInfo.firstName : ''
    },
    lastName() {
      return this.getClientProfile && this.getClientProfile.userInfo ? this.getClientProfile.userInfo.lastName : ''
    },
    dialogParams() {
      return { orderId: this.orderId }
    },
    withdrawalAmountCurrency() {
      let bnakcurrency = ''
      if (this.form.bank_card_number && this.form.bank_card_number.indexOf('(')) {
        let arr = this.form.bank_card_number.split('(')
        let arrs = arr[arr.length - 1].split(')')
        console.log(arrs)
        bnakcurrency = arrs[0]
      }
      if (!['USD', 'HKD', 'CNY'].includes(bnakcurrency)) {
        bnakcurrency = 'HKD'
      }
      if (['STOCK', 'FUTURES'].includes(this.type)) return bnakcurrency || 'HKD'
      if (['FOREX', 'PM'].includes(this.type)) return 'USD'
      return 'HKD'
    }
  },
  mounted() {
    // 仅有sp账户
    if (this.userInfo.isSPAccount === 'Y' && !this.filterSPTradingAccountList.length) {
      return (this.spdialogOpen = true)
    }
    this.refresh()
    this.getAllBank()
    this.getExchangeRate()
    this.getWithdrawalRecord()
  },
  watch: {
    withdrawal_method(val) {
      // let tradeAccount = this.form.tradeAccount
      // 调用子组件的clearImageKeys方法
      // this.$refs.uploadPicture.clearImageKeys()
      // let a = this.$refs['form'].resetFields()
      // console.log(this.form, a)

      this.resetForm()
      this.$nextTick(() => {
        if (val === 'LOCAL') {
          this.formComponent = 'localForm'
        } else if (val === 'OVERSEA') {
          this.formComponent = 'overseaForm'
        }
      })
    },
    'form.bank_card_number': function (val) {
      for (const value of this.bankCardNumber) {
        if (value.number === val) {
          this.bank_card_name = value.name
          console.log(this.bank_card_name)
          break
        }
      }
    }
  },
  methods: {
    handlePopClose() {
      this.popupVisible = false
    },
    isNeedPointFun(val) {
      this.isNeedPoint = val
    },
    checkRadioHandle() {
      this.isBandChecked = !this.isBandChecked
    },
    closeHandle() {
      this.isChecked = false
    },
    translateString(val, money) {
      let tipString = ''
      if (val && val.includes('{}')) {
        tipString = val.replace('{}', money)
      }
      return tipString
    },
    async getAllBank() {
      let params = {
        isSib: false
      }
      let res = await getAllBank(params)
      if (res.code === 200) {
        this.allOtherBanks = res.data
      }
    },
    async getExchangeRate() {
      let res = await exchangeRateApi.getExchangeRate()
      this.sellRate = (res && res.data) || {}
    },
    tradeAccountConfig(tradeAccountType) {
      return this.Util.getTradeAccountConfig(tradeAccountType)
    },
    cancelWithdrawal() {
      let options = {
        orderId: this.cancelOrderId
      }
      this.loadingSub = true
      api1.cancelWithdrawal(options).then(result => {
        this.IsCancelShow = false
        this.loadingSub = false
        this.openMessage('success', this.$t('common.cencel_dialog.cancel.withdrawal'))
        setTimeout(() => {
          this.getWithdrawalRecord()
        }, 600)
      }).catch(err => {
        this.loadingSub = false
        console.log(err)
        if (err.code === '510') {
          this.$message.error(this.$t('common.noCancel'))
        }
      })
    },
    cencelFun(val) {
      console.log('----->', val)
      this.cancelOrderId = val
      this.IsCancelShow = true
    },
    async groupByCurrency(tradeAccount) {
      // 入金成功的货币就是出金可以选择的货币
      let option = {}
      let tempCurrency = []
      option.groupBy = '$exchangedCurrency'
      option['tradeAccount'] = tradeAccount
      option['status'] = 'COMPLETED'
      option.viewType = 'deposit'
      const result = await this.$api.groupByCurrency(option)
      if (result.code === 200) {
        result.data.map(item => {
          tempCurrency.push(item._id)
        })
      }
      return tempCurrency
    },
    async getAccountNumber(tradeAccountObj) {
      this.isDormant = tradeAccountObj.isDormant
      if (tradeAccountObj.type !== 'STOCK') {
        this.bankCardNumber = this.oldBankCardNumber.filter(item => item.type !== 'yz')
      } else {
        this.bankCardNumber = this.oldBankCardNumber
      }
      try {
        this.formLoading = true
        let tradeAccount = tradeAccountObj.value
        // 可取款额度是否显示
        this.currencyList = []
        this.cashList = []
        this.form.tradeAccount = tradeAccount
        this.tmp_account_number = tradeAccount
        this.accountType = tradeAccountObj.accountType
        this.tradeAccountType = tradeAccountObj._tradeAccountType
        let currency = this.tradeAccountConfig(tradeAccountObj.tradeAccountType)['currency']['value']
        this.currency = currency
        this.accountId = tradeAccountObj.accountId
        this.type = tradeAccountObj.type
        if (!this.tradeAccountConfig(tradeAccountObj.tradeAccountType)['isTradeAccountExit']) {
          // eslint-disable-next-line no-throw-literal
          throw { code: '5003', msg: 'tradeAccountType is lost' }
        }
        this.showBalance = this.tradeAccountConfig(tradeAccountObj.tradeAccountType)['showBalance']
        if (this.showBalance && tradeAccountObj.type !== 'STOCK' && tradeAccountObj.type !== 'FUND') {
          const res = await this.getTradeAccountBalance(tradeAccount, this.tradeAccountType)
          this.formLoading = false
          if (!res.data) {
            let message = this.$t(`errMessage.11000`)
            return this.$message({
              showClose: true,
              message: message,
              type: 'error'
            })
          }
          this.cashList = res.data
        } else {
          this.getNewBalance(tradeAccountObj)
        }
      } catch (error) {
        this.formLoading = false
        console.log('>>>>error', error)
        let message = this.$t(`errMessage.11000`)
        this.$message({
          showClose: true,
          message: message,
          type: 'error'
        })
      }
    },
    async getTradeAccountBalance(val, tradeAccountType) {
      try {
        const result = await api.getUserBalance({
          tradeAccountNumber: val,
          tradeAccountType
        })
        return result
      } catch (error) {
        console.log('>>>>>>获取交易账户余额异常', error)
        let accountInfo = this.$t(`tradeAccountType.${tradeAccountType}`) + val
        let errorMessage = accountInfo + this.$t(`errMessage.${error.code}`)
        this.$message.error(errorMessage)
        throw error
      }
    },
    refresh() {
      // let accountNumber = this.getAccountInfo.accountNumber
      Promise.all(
        [
          // this.$api.getWithdrawalRecords({
          //   limit: 3,
          //   // accountNumber: this.accountNumber,
          //   // tradeAccount: tradeAccount,
          //   searchParams: {
          //     accountNumber: accountNumber
          //   },
          //   viewType: 'withdrawal',
          //   sortKey: 'createdTime',
          //   sortVal: '-1'
          // }),
          // api1.getWithdrawalRecord(),
          this.getBanksList()
          // this.$api.getAccountInfo(),
          // this.$api.getBankInfo({
          //   accountNumber: accountNumber
          //   // accountNumber: "1008611001",
          // })
        ].map(promiseItem => {
          return promiseItem.catch(err => {
            this.openMessage('error', err)
            return err
          })
        })
      )
        .then(result => {
          delete this.form['checked']
          this.form.tradeAccount = this.tmp_account_number
          // if (result[0]['code'] === 200 && Object.keys(result[0].data).length) {
          //   this.initTreeList(result[0].data)
          // }

          if (result[0]['code'] === 200 && Object.keys(result[0].data).length) {
            console.log('result[0]', result[0])
            let bankCardNumberArr = result[0].data
            let filterArr = ['JPY', 'SGD', 'MYR', 'IDR'] // 过滤东南亚二期币种
            bankCardNumberArr.commonBankList = bankCardNumberArr.commonBankList && bankCardNumberArr.commonBankList.length ? bankCardNumberArr.commonBankList.filter(item => {
              return !filterArr.includes(item.currency)
            }) : []
            this.bankCardNumber = []
            let bankCardList = []
            bankCardList[0] = {
              label: this.$t('common.yzAccount'),
              type: 'yz',
              options: bankCardNumberArr.bankSecuritiesList
            }
            bankCardList[1] = {
              label: this.$t('common.commonAccount'),
              type: 'common',
              options: bankCardNumberArr.commonBankList
            }
            bankCardList[1].options.push({ label: this.$t('common.otherText'), number: 'other', name: this.$t('common.otherText'), account: '' })
            this.bankCardNumber = this.formatBankCardNumberArr(bankCardList)
            this.oldBankCardNumber = JSON.parse(JSON.stringify(this.bankCardNumber))
          }
        })
        .catch(error => {
          console.log('catch')
          console.log(error)
        })
        .finally(() => {
          // 银行卡号添加其他银行选项
          // this.bankCardNumber.push({ label: '其他', number: 'other', text: '其他' })
          console.log('this.bankCardNumber', this.bankCardNumber)
        })
    },
    async getWithdrawalRecord() {
      let res = await api1.getWithdrawalRecord()
      if (res && res.code === 200) {
        this.initTreeList(res.data || [])
      } else {
        console.log('error')
      }
    },
    formatBankCardNumberArr(arr) {
      console.log(arr, '------qweeee')
      let newArr = arr.map(item => {
        return {
          label: item.label,
          type: item.type,
          options: item.options.map(optionsItem => {
            let currency = optionsItem.currency ? '[' + this.$t(`common.${optionsItem.currency.toLowerCase()}`) + ']' : ''
            return {
              ...optionsItem,
              label: `${currency}${optionsItem.name} ${optionsItem.account ? ` | ${optionsItem.account}` : ''}`,
              labelValue: `${optionsItem.name} ${optionsItem.account ? ` | ${optionsItem.account}` : ''}(${optionsItem.currency})`,
              groupList: optionsItem.groupList ? optionsItem.groupList.map(groupListitem => {
                return {
                  ...groupListitem,
                  text: `${groupListitem.name} | ${groupListitem.account}(${groupListitem.currency})`
                }
              }) : null
            }
          })
        }
      })
      return newArr
    },
    resetForm() {
      this.$refs.withdrawalForm.resetForm()
    },
    // 本地出金重置后返回新的表单数据重新组装
    resetWithdrawalForm(form, type, imageKeys) {
      this.form = form
      this.type = type
      this.imageKeys = imageKeys
    },
    initTreeList(data) {
      console.log(data)
      this.oldListData = data
      this.parentList = []
      data.forEach(element => {
        let item = {}
        item.applyTime = moment(element.createdDate).format('YYYY-MM-DD HH:mm:ss')
        item.status = element.status
        item.orderId = element.orderId
        item.childList = element.withdrawalsType === '"OVERSEA"' ? {
          accountNo: element.tradeAccountNumber,
          bankCard: element.bankAccount,
          enName: element.enName,
          swiftNo: element.swiftCode,
          withdrawalAmout:
            element.withdrawalCurrency +
            ' ' +
            this.Util.formatCurrency(element.withdrawalAmount),
          // fundBankType: element.fundBankType,
          applyTime: moment(element.createdDate).format('YYYY-MM-DD HH:mm:ss')

        } : {
          accountNo: element.tradeAccountNumber,
          bankCard: element.bankAccount,
          withdrawalAmout:
            element.withdrawalCurrency +
            ' ' +
            this.Util.formatCurrency(element.withdrawalAmount),
          withdrawoutWay: element.fundBankType === 'BANK_SECURITIES' ? this.$t('common.yztransfer') : '',
          applyTime: moment(element.createdDate).format('YYYY-MM-DD HH:mm:ss')
        }
        if (['FAILURE', 'WITHDRAWN'].includes(item.status)) {
          Object.assign(item.childList, { remark: element.remark })
        }
        if (element.fundBankType !== 'BANK_SECURITIES') {
          delete item.childList.withdrawoutWay
        }
        this.parentList.push(item)
      })
      this.parentList = this.parentList.slice(0, 3)
      // console.log(this.parentList, 'this.parentList')
    },
    closeChange() {
      this.openMessage('success', this.$t('withdrawal.success'))
    },
    confirm () {
      if (this.type === 'FOREX' && !this.isChecked) {
        this.$message.error(this.$t('withdrawal.checkInfo'))
        return
      }
      this.$confirm(this.$t('withdrawal.oversea_tip'), '提示', {
        confirmButtonText: this.$t('common.ok'),
        cancelButtonText: this.$t('common.cancel'),
        confirmButtonClass: 'withdrawalConfirmButton',
        type: 'warning'
      })
        .then(() => {
          this.handle()
        })
        .catch(() => {
          // this.closeModal = true;
          // this.IsPreviewShow = false;
          // this.loadingSub = false;
        })
    },
    handle() {
      this.closeModal = false
      let withdrawalData = {}
      let bankNuber = ''
      if (this.type === 'FOREX' && !this.isChecked) {
        this.$message.error(this.$t('withdrawal.checkInfo'))
        return
      }
      this.loading = true
      if (this.withdrawal_method === 'LOCAL') {
        if (this.form.bank_card_number.indexOf('|') > 0) {
          bankNuber = this.form.bank_card_number.split(' | ')[1].split('(')[0]
        } else {
          bankNuber = this.form.bank_card_number
        }
      }
      withdrawalData = {
        'bankAccount': this.withdrawal_method === 'LOCAL' ? bankNuber : this.form.withdrawal_bank_card,
        'bankName': this.withdrawal_method === 'LOCAL' ? this.form.bank_card_name : this.form.withdrawal_bank_name,
        'bankSwiftCode': this.form.withdrawal_swift_no,
        'enName': this.form.withdrawal_name,
        'submitSource': 'CP_WEB',
        'tradeAccountNumber': this.form.tradeAccount,
        'tradeAccountType': this.tradeAccountType,
        'withdrawalAmount': this.form.withdrawal_amount,
        'withdrawalCurrency': this.withdrawalAmountCurrency,
        'withdrawalImages': this.imageKeys,
        'withdrawalType': this.withdrawal_method === 'LOCAL' ? 'LOCAL' : 'OVERSEA',
        'bankType': this.form.bankType,
        'bankCode': this.form.bank_card_code,
        'serviceCharge': this.form.serviceCharge,
        'actualAmount': this.form.actualAmount,
        'isAddBank': this.isBandChecked
      }
      api1
        .commitWithdrawal(withdrawalData)
        .then(result => {
          if (result.code === 200) {
            this.dialogVisible = false
            this.loading = false
            this.orderId = result.data.orderId
            this.IsCodeShow = true
            this.closeModal = false
            this.checked = false
            this.resetForm()
            this.getWithdrawalRecord()
            // this.successConfirm();
            // this.openMessage("success", this.$t('withdrawal.success'));
          } else {
            this.loading = false
            this.$message.error(this.$t('withdrawal.error_submit'))
          }
        }).catch(e => {
          this.loading = false
          // this.$message.error(e.msg)
        })
    },
    submitFn(form, type, imageKeys) {
      if (this.isDormant) {
        this.popupVisible = true
        return
      }
      this.form = form
      console.log(form, 'form')
      let previewData = JSON.parse(JSON.stringify(form))
      delete previewData.bankType
      delete previewData.bank_card_code
      delete previewData.currency
      this.previewData = previewData
      if (this.withdrawal_method === 'LOCAL') {
        // delete previewData.serviceCharge
        if (previewData.accountFee && !previewData.financeFee) {
          // 仅有账户管理费
          this.subTip = this.$t('common.preview_dialog.withdrawalTip')
          delete previewData.financeFee
        } else if (!previewData.accountFee && previewData.financeFee) {
          // 仅有一手融手续费
          this.subTip = this.translateString(this.$t('common.preview_dialog.withdrawalfinanceTip'), `${form.currency}${this.Util.formatCurrency(previewData.financeFee)}`)
          delete previewData.accountFee
        } else if (previewData.accountFee && previewData.financeFee) {
          // 账户管理费和一手融手续费都有
          this.subTip = this.translateString(this.$t('common.preview_dialog.withdrawalallTip'), `${form.currency}${this.Util.formatCurrency(previewData.financeFee)}`)
        } else {
          this.subTip = this.$t('common.preview_dialog.tip.withdrawal')
          delete previewData.financeFee
          delete previewData.accountFee
        }
        // 香港银行账户 且银行为其他时弹窗提示绑定为出金银行卡
        if (form.bankType === 'OTHER') {
          this.isOtherBank = true
          this.isBandChecked = true
        } else {
          this.isOtherBank = false
          this.isBandChecked = false
          delete previewData.bank_card_name
        }
      }
      if (this.withdrawal_method !== 'LOCAL') {
        this.isOtherBank = false
        this.isBandChecked = false
        console.log(previewData, 'previewData')
        let otherTip = this.$t('withdrawal.otherTip').replace('{}', 4)
        this.subTip = this.$t('common.preview_dialog.tip1') + otherTip
        if (previewData.accountFee && !previewData.financeFee) {
          // 仅有账户管理费
          let otherTip = this.$t('withdrawal.otherTip').replace('{}', 6)
          this.subTip = this.$t('common.preview_dialog.overseaTip') + otherTip
          delete previewData.financeFee
        } else if (!previewData.accountFee && previewData.financeFee) {
          // 仅有一手融手续费
          let otherTip = this.$t('withdrawal.otherTip').replace('{}', 6)
          this.subTip = this.translateString(this.$t('common.preview_dialog.overseafinanceTip'), `${form.currency}${this.Util.formatCurrency(previewData.financeFee)}`) + otherTip
          delete previewData.accountFee
        } else if (previewData.accountFee && previewData.financeFee) {
          // 账户管理费和一手融手续费都有
          let otherTip = this.$t('withdrawal.otherTip').replace('{}', 7)
          this.subTip = this.translateString(this.$t('common.preview_dialog.overseaallTip'), `${form.currency}${this.Util.formatCurrency(previewData.financeFee)}`) + otherTip
        } else {
          delete previewData.financeFee
          delete previewData.accountFee
        }
      }
      this.type = type
      this.imageKeys = imageKeys
      this.dialogVisible = true
    },
    successConfirm() {
      this.$refs.withdrawal.dialogFormVisible = true
    },
    // selectAccout (accNum) {
    //   for (const value of this.accountInfo) {
    //     if (value.number === accNum) {
    //       this.available_fund = value.balance
    //       this.currency = value.currency
    //       break
    //     }
    //   }
    // },
    checkUnprocessed(tradeAccount) {
      return new Promise((resolve, reject) => {
        this.$api
          .withdrawalRecords({
            accountNumber: this.getAccountInfo.accountNumber,
            tradeAccount: tradeAccount,
            status: ['submitted', 'checking', 'verified', 'processing'],
            viewType: 'withdrawal'
          })
          .then(result => {
            if (result['code'] === 200) {
              let submittedOrder = result.data.count
              if (submittedOrder) {
                this.openMessage(
                  'warning',
                  this.$t('withdrawal.error_withdrawal_check')
                )
                return resolve(false)
              }
              return resolve(true)
            }
          })
      })
    },
    async getBanksList() {
      try {
        let params = {
          isSib: false,
          addressType: 'HongKong'
        }
        let result = await settlementAccount(params)

        return result
      } catch (e) {
        e.msg && this.$message.error(e.msg)
      }
    },
    showDialogHandle() {
      this.showDialog = true
    },
    async getNewBalance(val) {
      let params = {
        tradeAccount: val.value,
        accountType: val._tradeAccountType
      }
      let res = await api.getNewBalance(params)
      this.formLoading = false
      if (res && res.code === 200) {
        this.cashList = res.data.map(item => {
          return {
            ...item,
            amount: Number(item.awb),
            maxAmount: Number(item.finalAWB)
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
.page-withdrawal {
  height: min-content;
  margin-top: 0;

  color: rgba(229, 141, 21, 1);
  .error-dialog{
    .footer-box{
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .el-dialog__header{
      text-align: center;
      font-weight: 600;
    }
  }
  .checkboxTips {
    // margin: 20px auto;
    // padding-left: 2%;
    display: flex;
    align-items: center;
    width: 100%;
    .el-checkbox__input {
      vertical-align: middle;
      margin-right: 8px;
    }
    .el-checkbox__label {
      font-size: 14px !important;
      color: #333;
      width: 100% !important;
      white-space: normal;
    }
  }
  .depositReciepTips {
    width: 96%;
    background: #f4f4f4;
    border-left: 3px solid #fec000;
    padding: 2%;
    margin-top: 10px;
    p {
      margin: 0;
      line-height: 20px;
    }
    .ReciepTipsTitle {
      font-size: 20px;
      font-weight: 600;
    }
  }
  .fund-transfer {
    background: #fff;
    // margin: 30px;
    padding: 20px 30px 86px 30px;
  }

  .withdrawal-title {
    border-bottom: 4px solid #e2e2e2;
    margin: 0 0 20px;
    padding-bottom: 20px;
    font-weight: 600;
    color: #182a54;
    font-size: 18px;
    font-family: Muli-Bold;
  }

  .oversea-notices {
    background: rgba(254, 192, 0, 0.2);
    height: 50px;
    padding: 0 20px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;

    img {
      vertical-align: middle;
    }

    b {
      width: 100%;
      font-family: Muli-Bold;
      font-size: 14px;
      color: #192b57;
      letter-spacing: 0;
      // line-height: 50px;
      padding-left: 20px;
    }
  }

  .el-radio-group {
    width: 100%;
    border: 1px solid #001d50;
    border-radius: 5px;
  }

  .el-select {
    border-color: #fec000;
  }

  .el-form--label-top .el-form-item__label {
    font-family: Muli-Bold;
    font-size: 12px;
    color: #7d7d7d;
    letter-spacing: 0.13px;
    text-align: right;
    padding: 0;
  }

  .el-input__inner {
    font-family: Muli-Bold;
    font-size: 14px;
    color: #24282d;
    letter-spacing: 0;
    height: 45px;
    height: 45px;
    // border-color: #fec000;
  }
  .el-radio-button {
    width: 50%;

    .el-radio-button__inner {
      width: 100%;
      font-size: 13px;
      padding-left: 6px;
      padding-right: 6px;
    }
  }

  .el-radio-button__inner {
    padding: 20px;
    font-family: Muli-Bold;
    font-size: 14px;
    color: #2c3850;
    letter-spacing: 0.17px;
    text-align: center;
  }

  .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background: #2c3850;
    border-color: #001d50;
  }

  // .el-radio-button__inner:hover {
  //   color: #f3f4f6
  // }

  .el-form-item {
    margin-bottom: 15px;
  }
  .page-withdrawal .oversea-notices b {
    font-size: 13px;
  }
  .el-form-item.is-success .el-input__inner {
    border-color: #e2e2e2;
  }

  .el-form-item.is-success .el-input__inner:focus {
    border-color: #e2e2e2;
  }

  .el-form-item.is-success {
    border-color: #e2e2e2;
  }

  .el-input-group__prepend {
    font-family: Muli-Bold;
    font-size: 14px;
    color: #23282e;
    letter-spacing: 0.17px;
    background-color: #f3f4f6;
  }

  .el-select .el-input .el-select__caret {
    font-weight: bold;
    color: #fec000;
  }

  .money-icon {
    height: 45px;
    line-height: 45px;
    font-family: Muli-Bold;
    padding: 0px 5px;
    font-size: 14px;
    color: #000000;
    letter-spacing: 0.17px;
  }
  .input_aomut .el-input__inner {
    padding-left: 40px;
  }
  .el-input.is-disabled .el-input__inner {
    background-color: #e2e2e2;
    color: #000000;
  }
  .submit-primary-btn {
    color: #192b57;
    width: 15rem;
    height: 3.5rem;
    margin-top: 20px;
    span {
      font-family: Muli-Bold;
      font-size: 14px;
      color: #193060;
      letter-spacing: 0.17px;
      text-align: center;
    }
  }

  .records-list-tree {
    margin-top: 0px;
    padding: 0 20px 10px;
  }

  hr {
    border: 2px solid #eee;
    margin: 20px 0;
  }

  .el-select {
    width: 100%;
  }

  .text-orange {
    color: #fec000;
  }

  .account-info {
    margin-top: 30px;
    padding: 30px;
  }

  .title {
    span,
    small {
      display: inline-block;
      width: 50%;
    }

    small {
      font-weight: normal;
      font-size: 1rem;
      text-align: right;
    }
  }

  .money {
    border: 10px solid #eee;

    .balance {
      border-bottom: 6px solid #eee;
    }
  }

  .other-info {
    padding: 10px 0;
    border-bottom: 1px solid #eee;

    .label {
      color: #666;
    }
  }

  .left-card {
    margin-left: 0rem !important;
    margin-right: 0rem !important;
  }

  .wrapper {
    background: #fff;
    padding: 30px;
    margin-top: 20px;
    margin-bottom: 20px;
    border-radius: 5px;
    box-shadow: 0 3px 6px 0 rgba(40, 40, 90, 0.09),
      0 1px 1px 0 rgba(0, 0, 0, 0.065);

    .note {
      border-left: 4px solid #fec000;
      background: #f3f4f6;
      padding: 20px;
      font-size: 14px;
      color: #666666;
      b {
        color: #e02a2a;
      }
    }
  }
  .currency-input {
    width: 120px;
    font-family: Muli-Bold !important;
  }
  .line-space-input {
    margin-top: 15px !important;
  }
  .tips-font-style {
    line-height: 30px;
  }
  .liquidation-box {
    color: #f13e3d;
    font-size: 14px;
    padding: 20px 0;
  }
}
@media (max-width: 768px) {
  .layout-container .container .view {
    max-width: 100%;
    padding: 0 !important;
    margin: 0 !important;
  }
  .row-wrap {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .p0 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .withdrawal-records {
    margin-top: 20px;
  }
  .oversea-notices {
    height: auto !important;
    font-size: 12px !important;
    line-height: 25px;
  }
}
.check-box{
  padding: 20px 0;
  width: 100%;
}
.check-box-band {
  padding: 20px 0 10px;
  display: flex;
  align-items: center;
  line-height: 14px;
  color: #24282d;
  img {
    width: 14px;
    height: 14px;
    margin-right: 10px;
  }
}
.warn-info {
  padding: 0 0 10px;
  font-size: 12px;
  color: #92929e;
}
.warn-dialog {
  .dialog-info {
    font-size: 14px;
    font-weight: 400;
    color: #7d7d7d;
    line-height: 21px;
    &:first-of-type {
      margin-bottom: 15px;
    }
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
    padding-top: 30px;
    .el-button {
      padding: 18px 96px;
      background: #fec000;
      border-radius: 5px;
      color: #192b57;
      font-size: 14px;
    }
  }
}
.btn-box-one {
  padding-top: 30px;
  .top {
    margin-bottom: 0;
  }
}
.btn-box {
  font-size: 14px;
  font-weight: 600;
  color: #193060;
  line-height: 20px;
  width: 120px;
  margin: auto;
  text-align: center;

  .top {
    background: #fec000;
    border-radius: 5px;
    padding: 15px 0;
    margin-bottom: 20px;
    cursor: pointer;
  }
  .bottom {
    border-radius: 5px;
    border: 1px solid #193060;
    padding: 15px 0;
    cursor: pointer;
  }
}
</style>
